import { html, TemplateResult } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

// --------------------------------------------------------
// Plain HTML Sources
// --------------------------------------------------------

export const sourceNoResults = `
    <!-- BEGIN no results -->
    <ux-iws-search-no-results>
    <div class="ux-row ux-u-mx-zero">
        <div
            class="ux-col-12 ux-col-sm-10 ux-u-offset-sm-1 ux-col-lg-8 ux-u-offset-lg-2 ux-u-margin-bottom-30 ux-u-px-l ux-u-text-align--center"
        >
            <div class="ux-text-headline ux-text-headline--medium">
                Für diesen Suchbegriff konnten wir leider keine Treffer
                finden.
                <br />Meinten Sie
                <a
                    class="ux-text-link--green"
                    href="?TruFibre"
                    data-ux-iws-search="TruFibre"
                    >TruFibre</a
                >,
                <a
                    class="ux-text-link--green"
                    href="?TruLaser"
                    data-ux-iws-search="TruLaser"
                    >TruLaser</a
                > oder
                <a
                    class="ux-text-link--green"
                    href="?TruMark"
                    data-ux-iws-search="TruMark"
                    >TruMark</a
                >?
            </div>
            <p class="ux-text">
                Bitte prüfen Sie, ob der Suchbegriff korrekt geschrieben ist
                oder versuchen Sie es mit einem ähnlichen Begriff. <br/>
                Sie können auch jederzeit gerne direkt mit TRUMPF in Kontakt
                treten oder einen der häufigsten Suchbegriffe auswählen:
            </p>
            <ul class="ux-iws-search-no-results__popular-searches">
                ${[
                    "Karriere",
                    "Intech 2024",
                    "Erfolgsgeschichten",
                    "Lorem Ipsum",
                ]
                    .map(
                        (term) => `
                        <li>
                            <a
                                class="ux-text-link--green"
                                href="?${term}"
                                data-ux-iws-search="${term}"
                                >${term}</a
                            >
                        </li>
                    `
                    )
                    .join("")}
            </ul>
            <div>
                <a class="ux-button" href="#">Zum Kontaktformular</a>
            </div>
        </div>
    </div>
    </ux-iws-search-no-results>
    <!-- END no results -->
`;

export const sourceResultItemPage = `
    <ux-iws-link-wrapper class="ux-iws-teaser-page">
        <div class="ux-iws-teaser-page__container">
            <div class="ux-iws-teaser-page__inner">
                <div class="ux-iws-teaser-page__header">
                    <ux-tag disabled>
                        Category
                    </ux-tag>
                    <p
                        class="ux-iws-teaser-page__title ux-text-headline ux-text-headline--small"
                    >
                        <a class="ux-iws-teaser-page__link" href="#">
                            Seitentitel Lorem Ipsum Dolor consectetur
                        </a>
                    </p>
                </div>
                <ux-text-lines-limit
                    text-lines-s="3"
                    text-lines-m="3"
                    text-lines-l="3"
                    text-lines-xl="2"
                >
                    <p class="ux-iws-teaser-page__description">
                        Description Lorem ipsum dolor sit amet, consetetur
                        sadipscing elitr, sed diam nonumy eirmod tempor invidunt
                        ut labore et dolore magna aliquyam erat, sed diam
                        voluptua. At vero eos et accusam et justo duo dolores et
                        ea rebum. Stet clita kasd gubergren, no sea takimata
                        sanctus est. Lorem ipsum dolor sit amet, consetetur.
                    </p>
                </ux-text-lines-limit>
            </div>
            <div class="ux-iws-teaser-page__link">
                <a
                    class="ux-button ux-button--icon-only"
                    href="#"
                    aria-label="Lorem Ipsum"
                    role="button"
                >
                    <ux-icon name="chevron-right"> </ux-icon>
                </a>
            </div>
        </div>
    </ux-iws-link-wrapper>
`;

export const sourceResultItemProduct = `
    <ux-iws-teaser-product-tile
        product-image-url="./mock-assets/images/TruLaser-highlight.png"
        product-name="TruLaser Tube 3000 fiber"
        product-desc="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."
        eyecatcher=".NEW">
        <a href="/link-to-product-details.html" class="ux-text-link ux-iws-teaser-product-tile__link">Zum Produkt
            <ux-icon name="arrow-small-right" />
        </a>
    </ux-iws-teaser-product-tile>
    <ux-iws-teaser-product-tile
        product-image-url="https://www.trumpf.com/filestorage/TRUMPF_Processed/_processed_/4/e/csm_TruLaserCell3000-product-picture_4db23088f0_61c3187439.jpg"
        product-name="TruLaser Cell 3000"
        product-desc="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."
        eyecatcher=".NEW">
        <a href="/link-to-product-details.html" class="ux-text-link ux-iws-teaser-product-tile__link">Zum Produkt
            <ux-icon name="arrow-small-right" />
        </a>
    </ux-iws-teaser-product-tile>
`;

export const sourceResultItemDownload = `
<ux-iws-teaser-download-tile
    link="./mock-assets/images/downloads/example-122x172.png"
    link-text="Download"
    tags="Whitepaper"
>
    <div slot="image">
        <img
            alt="Image Alt Text"
            width="122"
            height="172"
            src="./mock-assets/images/downloads/example-122x172.png"
        />
    </div>
    <h4 slot="title" class="ux-text-title ux-text-title--bold">
        Wir sind für Sie da!
    </h4>
    <ux-text-lines-limit slot="description" text-lines="3">
        <p class="ux-text-normal">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
            eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
            voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
            clita kasd gubergren, no.
        </p>
    </ux-text-lines-limit>
</ux-iws-teaser-download-tile>
<ux-iws-teaser-download-tile
    download="example-122x172.png"
    file-info="25.01.2025 – PDF 460 kB"
    link="./mock-assets/images/downloads/example-122x172.png"
    link-text="Download"
    tags="PDF"
>
    <div slot="image">
        <img
            alt="Image Alt Text"
            width="122"
            height="172"
            src="./mock-assets/images/downloads/example-122x172.png"
        />
    </div>
    <h4 slot="title" class="ux-text-title ux-text-title--bold">
        Wir sind für Sie da!
    </h4>
    <ux-text-lines-limit slot="description" text-lines="3">
        <p class="ux-text-normal">
            Lorem ipsum dolor sit amet consetetur.
        </p>
    </ux-text-lines-limit>
</ux-iws-teaser-download-tile>
`;

export const sourceResultItemContact = `
    <div class="ux-iws-teaser-contact">
        <div class="ux-iws-teaser-contact__inner">
            <div class="ux-iws-teaser-contact__information">
                <div class="ux-iws-teaser-contact__image-wrapper">
                    <picture>
                        <source
                            media="(max-width: 567px)"
                            data-srcset='data:image/svg+xml,<svg xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" viewBox%3D"0 0 300 400" style%3D"background%3A %23e7e7e7"> <svg xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" viewBox%3D"-22.4 -37.5 135 165"> <path fill%3D"%23a1a1a1" d%3D"M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z"%2F> <%2Fsvg> <%2Fsvg>'
                        />
                        <source
                            media="(max-width: 1024px)"
                            data-srcset='data:image/svg+xml,<svg xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" viewBox%3D"0 0 300 400" style%3D"background%3A %23e7e7e7"> <svg xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" viewBox%3D"-22.4 -37.5 135 165"> <path fill%3D"%23a1a1a1" d%3D"M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z"%2F> <%2Fsvg> <%2Fsvg>'
                        />
                        <source
                            data-srcset='data:image/svg+xml,<svg xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" viewBox%3D"0 0 300 400" style%3D"background%3A %23e7e7e7"> <svg xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" viewBox%3D"-22.4 -37.5 135 165"> <path fill%3D"%23a1a1a1" d%3D"M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z"%2F> <%2Fsvg> <%2Fsvg>'
                        />
                        <img
                            alt=""
                            class="lazyload"
                            data-srcset='data:image/svg+xml,<svg xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" viewBox%3D"0 0 300 400" style%3D"background%3A %23e7e7e7"> <svg xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" viewBox%3D"-22.4 -37.5 135 165"> <path fill%3D"%23a1a1a1" d%3D"M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z"%2F> <%2Fsvg> <%2Fsvg>'
                            src='data:image/svg+xml,<svg xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" viewBox%3D"0 0 300 400" style%3D"background%3A %23e7e7e7"> <svg xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg" viewBox%3D"-22.4 -37.5 135 165"> <path fill%3D"%23a1a1a1" d%3D"M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z"%2F> <%2Fsvg> <%2Fsvg>'
                            style="display: block;"
                        />
                    </picture>
                </div>
                <div class="ux-iws-teaser-contact__name-title">
                    <p class="ux-text-normal">Thomas Mischer</p>
                    <div class="ux-text-tiny ux-u-text-uppercase">
                        <strong>role in the company</strong>
                    </div>
                </div>
                <div class="ux-iws-teaser-contact__contacts">
                    <a href="#" class="ux-text-link ux-text-link--green"
                        >M: thomas.mischer@trumpf.com</a
                    >
                    <a href="#" class="ux-text-link ux-text-link--green"
                        >T: +49 152 4427217</a
                    >
                </div>
            </div>
        </div>
    </div>
`;

export const sourceResultItemEvent = `
    <ux-iws-link-wrapper class="ux-iws-teaser-event">
        <div class="ux-iws-teaser-event__date-wrapper">
            <span class="ux-iws-teaser-event__year">
                2021
            </span>
            <span class="ux-iws-teaser-event__date">
                <span>Feb.</span>
                <span>12-14</span>
            </span>
        </div>
        <div class="ux-iws-teaser-event__content-wrapper">
            <span class="ux-iws-teaser-event__location">
                Halle 8, Stand 34B
            </span>
            <p class="ux-text-title-teaser ux-u-margin-top-5 ux-u-margin-bottom-10">
                Laser World of Photonics China 2021
            </p>
            <ux-tag disabled>
                power tools
            </ux-tag>
            <a class="ux-button" href="#">
                messe, austellung
            </a>
        </div>
    </ux-iws-link-wrapper>
`;

export const sourceTabGpt = `
    <!-- BEGIN tab gpt -->
    <ux-tab tab-id="tab-gpt" name="">
        <span slot="label"> TRUMPF GPT&nbsp;<sup>Beta</sup> </span>
        <div class="ux-row ux-u-mx-zero">
            <div class="ux-col-12 ux-col-sm-10 ux-u-offset-sm-1">
                <div class="ux-u-mt-xs">
                    GPT Code Snippet goes here
                </div>
            </div>
        </div>
    </ux-tab>
    <!-- END tab gpt -->
`;

export const renderTabGptWidget = (token: string) => html`
    <!-- BEGIN tab gpt -->
    <ux-tab tab-id="tab-gpt" name="">
        <span slot="label"> TRUMPF GPT&nbsp;<sup>Beta</sup> </span>
        <div class="ux-row ux-u-mx-zero ux-u-flex-jc-center">
            <div class="ux-col-12 ux-col-sm-10 ux-col-lg-8">
                <div class="ux-u-mt-xs">
                    <div
                        id="loyjoy-chat"
                        style="position:relative;z-index:0;width:100%;height: calc(100vh - 240px);"
                    ></div>
                    <script
                        async
                        defer
                        src="https://stable.loyjoy.com/widget.js?process=${token}"
                    ></script>
                </div>
            </div>
        </div>
    </ux-tab>
    <!-- END tab gpt -->
`;

export const renderStaticSearchResults = (
    source: string | TemplateResult
) => html`
    <!-- BEGIN static search results -->
    ${typeof source === "string" ? unsafeHTML(source) : source}
    <!-- END static search results -->
`;

// --------------------------------------------------------
// Templates | Search Results Header | Summary
// --------------------------------------------------------

interface RenderSearchResultsSummaryProps {
    numResults?: number;
    name?: string;
    tabLink?: boolean;
}

export const renderSearchResultsSummary = ({
    numResults = 100,
    name = null,
    tabLink = false,
}: RenderSearchResultsSummaryProps) => html`
    <!-- BEGIN search results summary -->
    <div class="ux-iws-search-results__summary">
        <div class="ux-text-headline ux-text-headline--small ux-u-text-bold">
            ${name === null ? `${numResults} Treffer` : name}
            ${tabLink
                ? html`<a
                      class="ux-text-link ux-text-link--green ux-u-margin-left-10"
                      href="#"
                      data-ux-tab-target="${name
                          .replace(/\s.*/, "")
                          .toLowerCase()}"
                      >Alle anzeigen</a
                  >`
                : ""}
        </div>
    </div>
    <!-- END search results summary -->
`;

// --------------------------------------------------------
// Templates | Search Results Header | Tag Filter
// --------------------------------------------------------

interface RenderSearchTagFilterProps {
    endpoint?: string;
    multiSelect?: boolean;
    noCollapse?: boolean;
    resetFilterButton?: boolean;
}

export const renderSearchTagFilter = ({
    endpoint = "./mock-data/search-filter/search-filter-products.json",
    multiSelect = false,
    noCollapse = false,
    resetFilterButton = false,
}: RenderSearchTagFilterProps) => html`
    <!-- BEGIN search tag filter -->
    <div class="ux-iws-search-results__filter-container">
        <ux-iws-search-tag-filter
            endpoint=${ifDefined(endpoint)}
            ?multi-select=${ifDefined(multiSelect)}
            ?no-collapse=${ifDefined(noCollapse)}
            ?reset-filter-button=${ifDefined(resetFilterButton)}
        ></ux-iws-search-tag-filter>
    </div>
    <!-- END search tag filter -->
`;

// --------------------------------------------------------
// Templates | Search Results Header | Sort Form
// --------------------------------------------------------

export const renderSortForm = () => html`
    <!-- BEGIN search results sort form -->
    <div class="ux-iws-search-results__sort-container">
        <form class="ux-iws-search-results__sort">
            <div class="ux-select">
                <ux-icon class="ux-select__icon" name="chevron-down"></ux-icon>
                <select class="ux-select__select" name="sorting">
                    <option value="relevance-asc">Relevanz</option>
                    <option value="age-asc">Neueste</option>
                </select>
            </div>
        </form>
    </div>
    <!-- END search results sort form -->
`;

// --------------------------------------------------------
// Templates | Search Results Header
// --------------------------------------------------------

interface RenderSearchResultsHeaderProps {
    filterEndpoint?: string | undefined;
    numResults?: number;
    withFilter?: boolean;
    withSort?: boolean;
}

const renderSearchResultsHeader = ({
    filterEndpoint,
    numResults,
    withFilter,
    withSort,
}: RenderSearchResultsHeaderProps) => {
    const filterHtml =
        withFilter && typeof filterEndpoint === "string"
            ? renderSearchTagFilter({ endpoint: filterEndpoint })
            : "";
    const summaryHtml = renderSearchResultsSummary({ numResults });
    const sortHtml = withSort ? renderSortForm() : "";
    return html`
        <!-- BEGIN search results header -->
        <div class="ux-row ux-u-mx-zero ux-iws-search-results__header">
            <div class="ux-col-12 ux-col-sm-10 ux-u-offset-sm-1">
                ${filterHtml}
                <div class="ux-iws-search-results__header-row">
                    ${summaryHtml}${sortHtml}
                </div>
            </div>
        </div>
        <!-- END search results header -->
    `;
};

// --------------------------------------------------------
// Templates | Load More Button
// --------------------------------------------------------

const renderLoadMoreButton = ({ targetElementSelector }) => html`
    <!-- BEGIN load more button -->
    <ux-iws-load-more
        target-element-selector=${ifDefined(targetElementSelector)}
    >
        Load more
        <span slot="error"> There was an error while loading the data </span>
    </ux-iws-load-more>
    <!-- END load more button -->
`;

// --------------------------------------------------------
// Templates | Search Result
// --------------------------------------------------------

interface RenderSearchResultsRowProps {
    categoryId: string;
    containerClassName?: string;
    _slot?: string | TemplateResult;
}

const renderSearchResultsRow = ({
    categoryId,
    containerClassName,
    _slot,
}: RenderSearchResultsRowProps) => html`
    <!-- BEGIN search results layout wrapper -->
    <div class="ux-row ux-u-mx-zero">
        <div class="ux-col-12 ux-col-sm-10 ux-u-offset-sm-1">
            <!-- BEGIN search results container -->
            <div
                class="ux-iws-search-results__results-container${typeof containerClassName ===
                "string"
                    ? ` ${containerClassName}`
                    : ""}"
                data-id="ux-iws-search-results--${categoryId}"
            >
                ${typeof _slot === "string" ? unsafeHTML(_slot) : _slot}
            </div>
            <!-- END search results container -->
            ${renderLoadMoreButton({
                targetElementSelector: `[data-id=ux-iws-search-results--${categoryId}]`,
            })}
        </div>
    </div>
    <!-- END search results layout wrapper -->
`;

const renderSearchResultsRowSliders = ({
    categoryId,
    containerClassName,
    _slot,
}: RenderSearchResultsRowProps) => html`
    <!-- BEGIN search results layout wrapper -->
    <div class="ux-t-container-full">
        <!-- BEGIN search results container -->
        <div
            class="ux-iws-search-results__results-container${typeof containerClassName ===
            "string"
                ? ` ${containerClassName}`
                : ""}"
            data-id="ux-iws-search-results--${categoryId}"
        >
            ${typeof _slot === "string" ? unsafeHTML(_slot) : _slot}
        </div>
        <!-- END search results container -->
        ${renderLoadMoreButton({
            targetElementSelector: `[data-id=ux-iws-search-results--${categoryId}]`,
        })}
    </div>
    <!-- END search results layout wrapper -->
`;

// --------------------------------------------------------
// Templates | Search Category Tab
// --------------------------------------------------------

interface RenderTabProps extends RenderSearchResultsHeaderProps {
    categoryId?: string;
    numResults?: number;
    withStaticResults?: boolean;
}

// --------------------------------------------------------
// Templates | Search Category Tab | GPT
// --------------------------------------------------------

const renderTabGpt = () => html`${unsafeHTML(sourceTabGpt)}`;

// --------------------------------------------------------
// Templates | Search Category Tab | Pages
// --------------------------------------------------------

const renderTabPages = ({
    categoryId = "pages",
    numResults = 20,
    withFilter,
    withSort,
    withStaticResults,
}: RenderTabProps) => html`
    <!-- BEGIN tab pages -->
    <ux-tab tab-id="tab-${categoryId}" name="Alle Ergebnisse (${numResults})">
        <ux-iws-search-results
            category="${categoryId}"
            url="./mock-data/website-search-results_c-${categoryId}.html"
        >
            ${renderSearchResultsHeader({
                filterEndpoint: `./mock-data/search-filter/search-filter-${categoryId}.json`,
                numResults,
                withFilter,
                withSort,
            })}
            ${renderSearchResultsRow({
                categoryId,
                _slot: withStaticResults
                    ? renderStaticSearchResults(sourceResultItemPage.trim())
                    : "",
            })}
        </ux-iws-search-results>
    </ux-tab>
    <!-- END tab pages -->
`;

// --------------------------------------------------------
// Templates | Search Category Tab | Products
// --------------------------------------------------------

const renderTabProducts = ({
    categoryId = "products",
    numResults = 16,
    withFilter,
    withSort,
    withStaticResults,
}: RenderTabProps) => html`
    <!-- BEGIN tab products -->
    <ux-tab tab-id="tab-${categoryId}" name="Produkte (${numResults})">
        <ux-iws-search-results
            category="tab-${categoryId}"
            url="./mock-data/website-search-results_c-${categoryId}.html"
        >
            ${renderSearchResultsHeader({
                filterEndpoint: `./mock-data/search-filter/search-filter-${categoryId}.json`,
                numResults,
                withFilter,
                withSort,
            })}
            ${renderSearchResultsRow({
                categoryId,
                containerClassName: "ux-iws-teaser-product-tile-grid",
                _slot: withStaticResults
                    ? renderStaticSearchResults(sourceResultItemProduct.trim())
                    : "",
            })}
        </ux-iws-search-results>
    </ux-tab>
    <!-- END tab products -->
`;

// --------------------------------------------------------
// Templates | Search Category Tab | Downloads
// --------------------------------------------------------

const renderTabDownloads = ({
    categoryId = "downloads",
    numResults = 16,
    withSort,
    withStaticResults,
}: RenderTabProps) => html`
    <!-- BEGIN tab downloads -->
    <ux-tab tab-id="tab-${categoryId}" name="Downloads (${numResults})">
        <ux-iws-search-results
            category="tab-${categoryId}"
            url="./mock-data/website-search-results_c-${categoryId}.html"
        >
            ${renderSearchResultsHeader({
                numResults,
                withSort,
            })}
            ${renderSearchResultsRow({
                categoryId,
                containerClassName: "ux-iws-teaser-download-tile-grid",
                _slot: withStaticResults
                    ? renderStaticSearchResults(sourceResultItemDownload.trim())
                    : "",
            })}
        </ux-iws-search-results>
    </ux-tab>
    <!-- END tab downloads -->
`;

// --------------------------------------------------------
// Templates | Search Category Tab | Contacts
// --------------------------------------------------------

const renderTabContacts = ({
    categoryId = "contacts",
    numResults = 2,
    withSort,
    withStaticResults,
}: RenderTabProps) => html`
    <!-- BEGIN tab contacts -->
    <ux-tab tab-id="tab-${categoryId}" name="Kontakte (${numResults})">
        <ux-iws-search-results
            category="tab-${categoryId}"
            url="./mock-data/website-search-results_c-${categoryId}.html"
        >
            ${renderSearchResultsHeader({
                numResults,
                withSort,
            })}
            ${renderSearchResultsRow({
                categoryId,
                containerClassName: "ux-iws-teaser-contact-grid",
                _slot: withStaticResults
                    ? renderStaticSearchResults(sourceResultItemContact.trim())
                    : "",
            })}
        </ux-iws-search-results>
    </ux-tab>
    <!-- END tab contacts -->
`;

// --------------------------------------------------------
// Templates | Search Category Tab | Events
// --------------------------------------------------------

const renderTabEvents = ({
    categoryId = "events",
    numResults = 2,
    withSort,
    withStaticResults,
}: RenderTabProps) => html`
    <!-- BEGIN tab events -->
    <ux-tab tab-id="tab-${categoryId}" name="Termine (${numResults})">
        <ux-iws-search-results
            category="tab-${categoryId}"
            url="./mock-data/website-search-results_c-${categoryId}.html"
        >
            ${renderSearchResultsHeader({
                numResults,
                withSort,
            })}
            ${renderSearchResultsRow({
                categoryId,
                containerClassName: "ux-iws-teaser-event-grid",
                _slot: withStaticResults
                    ? renderStaticSearchResults(sourceResultItemEvent.trim())
                    : "",
            })}
        </ux-iws-search-results>
    </ux-tab>
    <!-- END tab events -->
`;

// --------------------------------------------------------
// Templates | Search Category Tab | All Categories
// --------------------------------------------------------

const renderTabAllCategories = ({
    categoryId = "all",
    numResults = 98,
}: RenderTabProps) => html`
    <!-- BEGIN tab all -->
    <ux-tab tab-id="tab-${categoryId}" name="Alle Ergebnisse (${numResults})">
        <ux-iws-search-results
            category="tab-${categoryId}"
            url="./mock-data/website-search-results_c-all-categories.html"
        >
            ${renderSearchResultsRowSliders({
                categoryId,
            })}
        </ux-iws-search-results>
    </ux-tab>
    <!-- END tab all -->
`;

// --------------------------------------------------------
// Templates | Search Result Tabs
// --------------------------------------------------------

export interface SearchResultTabsTemplateProps {
    noNavigation?: boolean;
    withFilter?: boolean;
    withSort?: boolean;
    withTabAllCategories?: boolean;
    withTabContacts?: boolean;
    withTabDownloads?: boolean;
    withTabEvents?: boolean;
    withTabPages?: boolean;
    withTabProducts?: boolean;
    withTabGPT?: boolean;
    withStaticResults?: boolean;
}

export const SearchResultTabsTemplate = ({
    noNavigation,
    withFilter,
    withSort,
    withTabAllCategories,
    withTabContacts,
    withTabDownloads,
    withTabEvents,
    withTabPages,
    withTabProducts,
    withTabGPT,
    withStaticResults,
}: SearchResultTabsTemplateProps) => {
    const tabProps: RenderTabProps = {
        withFilter,
        withSort,
        withStaticResults,
    };
    return html` <ux-tab-container
        id="search-result-tabs"
        no-navigation=${ifDefined(noNavigation)}
    >
        ${withTabAllCategories ? renderTabAllCategories(tabProps) : ""}
        ${withTabPages ? renderTabPages(tabProps) : ""}
        ${withTabGPT ? renderTabGpt() : ""}
        ${withTabProducts ? renderTabProducts(tabProps) : ""}
        ${withTabDownloads ? renderTabDownloads(tabProps) : ""}
        ${withTabContacts ? renderTabContacts(tabProps) : ""}
        ${withTabEvents ? renderTabEvents(tabProps) : ""}
    </ux-tab-container>`;
};
